import React from "react";
import PendingSMSCampaignPage from "../../../components/Pages/Campaign/PendingOrder/SMS";

const PendingSMSCampaign = () => {
  return (
    <div>
      <PendingSMSCampaignPage />
    </div>
  );
};

export default PendingSMSCampaign;
